import routes from 'sitewide-js/core_pre_webpack/routes';
import fetchWithCsrf from 'js/utils/fetch_with_csrf';
import { ResourceType } from 'js/social/shared/types';

const getRoute = (resourceType: ResourceType) => {
  return {
    post: routes.api_v0_community_post_feedback_path,
    paper_update: routes.api_v0_community_paper_update_feedback_path,
    openalex_work: undefined,
    comment: undefined,
    work: routes.api_v0_community_work_feedback_path,
    paper_set: undefined,
  }[resourceType];
};

export async function createContentFeedback(
  id: string | number,
  resourceType: ResourceType,
  feedbackType = 0,
  reason: number,
) {
  const route = getRoute(resourceType);
  if (!route) return;

  const response = await fetchWithCsrf(
    route({ subdomain_param: 'api', [`${resourceType}_id`]: id }),
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ feedback_type: feedbackType, reason }),
    },
  );
  if (response.status !== 200) {
    throw new Error('Failed to create feedback');
  }
  return await response.json();
}

export async function deleteContentFeedback(
  resourceId: string | number,
  feedbackId: string | number,
  resourceType: ResourceType,
) {
  const route = getRoute(resourceType);
  if (!route) return;

  const response = await fetchWithCsrf(
    route({ subdomain_param: 'api', [`${resourceType}_id`]: resourceId }),
    {
      method: 'DELETE',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ feedback_id: feedbackId }),
    },
  );
  if (response.status !== 200) {
    throw new Error('Failed to delete feedback');
  }
  return await response.json();
}
